import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7b72e9bedae70014127b42_1786901268203_d318a9cf/learnhub/src/app/course-catalogue/page.tsx");
